import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "../assets/css/button.css";
import "../assets/css/candidate-preview-form.css";
import DownloadIconBlack from "../assets/img/download-icon-black.svg";
import DownloadIconBlue from "../assets/img/download-icon-blue.svg";
import EditIcon from "../assets/img/edit-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  ProfilePreview,
  saveProfilePreviewDetails,
} from "../Actions/profilePreviewAction";
import { useNavigate } from "react-router-dom";
import { getLogout } from "../Actions/logoutAction";
import _ from "lodash";
import Loader from "./Common/loader";
import Footer from "./Footer.js";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import { SAVE_ONBOARDING_DETAILS_SUCCESS } from "../Constants/onboardingDetailsConstants.js";
import { deletePersonalDetailByClientData } from "../Actions/personalDetailByClientAction.js";

const CandidatePreviewFormData = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [data, setProfilePreviewData] = useState({});
  const [bankPreview,setBankPreview]=useState({});
  const [reference, setReference] = useState();
  const [enableSubmit,setEnableSubmit]=useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const storeData = useSelector((state) => state.profilePreview);
  const storeData2 = useSelector((state) => state.saveProfilePreview);
  const [role,setRole]=useState();
  const storeData5 = useSelector((state) => state.verifyCompleted);
  const dispatch = useDispatch();
  const storeData4 = useSelector((state) => state.verifyEmail);
  const { verifyEmailData,loading: getEmailLoading, err } = storeData4;
  const {
    profilePreviewData,
    loading: getLoading,
    error: getError,
  } = storeData;

  const [isOnboarding, setIsOnboarding] = useState();

  useEffect(() => {
    dispatch(deletePersonalDetailByClientData());
  },[])

  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getLoading]);
  const {
    saveProfilePreviewData,
    loading: saveLoading,
    error: saveError,
  } = storeData2;
  const { verifyCompletedData,loading: getVerifyCompletedLoading, erro } = storeData5;

  useEffect(() => {

    if (  typeof verifyCompletedData !== "undefined" &&
    verifyCompletedData !== null) {
      if(verifyCompletedData?.data?.isVerified == 1){
    setEnableSubmit(true);
      }
      // else if(verifyCompletedData?.data?.isVerified == 0){ 
      // let errMsg='Please verify your Email Account first on profile page to proceed further.';
      // toast.error(errMsg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      // setEnableSubmit(false);
      // }
     
    }
  }, [verifyCompletedData, storeData5]);
  
  useEffect(() => {

    if (  typeof verifyEmailData !== "undefined" &&
    verifyEmailData !== null) {
      // if(verifyEmailData.status !== "success"){
      //   let errMsg='Please verify your Email Account first on profile page to proceed further.';
      //   toast.error(errMsg, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   });
      //   setEnableSubmit(false);
      // }
     
    }
  }, [verifyEmailData, storeData4]);

//  debugger
  let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
  const isPrepaid = list.is_prepaid_client;
  console.log(isPrepaid);

  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [saveLoading]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    const role=autoLoginData?.data?.user_role;
    let ref = '';
    if(role === 'EP'){
      
      let list = JSON.parse(localStorage.getItem("autoLogin"));
      ref = list.data.reference_number;
    }else{
    let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    ref=list.reference_number;
    }
    
    setReference(ref);
  }, []);

  useEffect(() => {
    const isEveryFormCompleted = profilePreviewData.message ? true : false;
    if (isEveryFormCompleted) {
      navigate(role === "EP"?`/case-initiation/check-detail/${reference}/candidate-profile`:`/case-initiation/check-detail/${reference}/profile`)
      // navigate(`/case-initiation/check-detail/${reference}/profile`);
    }
    if (
      typeof profilePreviewData.data !== "undefined" &&
      profilePreviewData.data !== null
    ) {
      setProfilePreviewData(profilePreviewData.data);
      setIsOnboarding(profilePreviewData?.data?.onboardingFormCompleted);
      if(profilePreviewData?.data?.bank_account_details)
      setBankPreview(profilePreviewData?.data?.bank_account_details[0]); 
    }
  }, [profilePreviewData, storeData]);

  //console.log(data);

  useEffect(() => {
    const fetchData = async () => {
      
      dispatch(ProfilePreview());
    };
    fetchData();

    return () => {
      dispatch({
        type: SAVE_ONBOARDING_DETAILS_SUCCESS,
        payload: data,
      });
      dispatch({
        type: "PROFILE_PREVIEW_SUCCESS",
        payload: [],
      });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('InitialCaseId',saveProfilePreviewData?.initial_case_id);
    const hasReferenceNumber = saveProfilePreviewData.referenceNo
      ? true
      : false;
    if (hasReferenceNumber) {
      if (role=="EP" && isPrepaid=="1"){
       // navigate(`/candidate-form/client-thank-you/`);
       navigate('/candidate-form/client-thank-you-with-pay/');
      }
      else if(role=="EP" && isPrepaid=="0"){
        navigate(`/candidate-form/client-thank-you/`);
      }
      else{navigate(`/candidate-form/thank-you/`);}
    }
  }, [saveProfilePreviewData, storeData2]);
  
  const saveProfilePreview = (e) => {
    //alert('All the details will be submitted and you will not be able to make changes later. Please review your form and submit');
    e.preventDefault();
    let text =
      "All the details will be submitted and you will not be able to make changes later. Please review your form and submit";
    if (window.confirm(text) == true) {
      dispatch(saveProfilePreviewDetails());
    }
  };

  let compID = localStorage.getItem('CompanyIdOnboarding');
  const NomineeNameMapping = {
    'Form 2 (Part A)' : 'PF Nominee Details',
    'Form 2 (Part B)' : 'EPS Nominee Details',
    'Form F' : 'Gratuity Nominee Details',
    'Additional Details' : 'Additional Details',
    'Insurance & Other Details' : 'Insurance Nominee Details'
};

  let onboardingAdditionalName 
  
  if(compID == 2544 || compID == 3241 ){
   onboardingAdditionalName = 'Insurance & Other Details';
  }else{
   onboardingAdditionalName = 'Additional Details'
  }

  return (
    <>
      {isLoading && <Loader />}
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}
      <section className="main-section gray-bg" style={{ paddingTop: "60px" }}>
        <div className="container">
          <div className="row my-5">
            <div className="col-md-6">
              <h3 className="fnt-smi-bld mb-0">Preview</h3>
              <p className="text-muted mb-4 justify-content-start">Please review before submitting</p>
            </div>
            {/*{data.form_completion_date &&
            <div className="col-md-6 text-right txt-left-mbl">
                <span>Form Completion Date: {data.form_completion_date}</span>
            </div>
            }*/}
          </div>
          { !isOnboarding || role === "EP" ?
          <>
          {data.profile_details && (
            <div className="row mt-15">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5 className="fnt-smi-bld">
                      {data.profile_details.label}
                    </h5>
                    <h5 className="fnt-smi-bld"></h5>
                    {data.profile_details && (
                      <Link
                        to={role === "EP"?`/case-initiation/check-detail/${reference}/candidate-profile`:`/case-initiation/check-detail/${reference}/profile`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.profile_details &&
                    Object.entries(data.profile_details).map(([w, obj]) => {
                      if (obj.value != "" && obj.url != "") {
                        return (
                          <div className="row mt-1">
                            {obj.value && (
                              <div className="col-md-3 text-muted">
                                {obj.label}
                              </div>
                            )}
                            {obj.value && (
                              <div className="col-md-9">{obj.value}</div>
                            )}
                            {obj.url && (
                              <a
                                href={obj.url}
                                download
                                target="_blank"
                                className="col-md-3 text-primary d-inline-flex mr-3"
                              >
                                <img
                                  src={DownloadIconBlue}
                                  alt=""
                                  className="mr-1"
                                />{" "}
                                {obj.label}
                              </a>
                            )}
                          </div>
                        );
                      }
                    })}
                  {data.additional_details && (
                    <h5 className="fnt-smi-bld mt-2 mb-0">
                      Additional Details
                    </h5>
                  )}
                  {data.additional_details &&
                    Object.entries(data.additional_details).map(([d, obj]) => {
                      if (obj.value != "") {
                        return (
                          <div className="row mt-1">
                            <div className="col-md-3 text-muted">
                              {obj.label}
                            </div>
                            <div className="col-md-9 ">{obj.value}</div>
                          </div>
                        );
                      }
                    })}
                    {data.other_checks && (
                    <h5 className="fnt-smi-bld mt-2 mb-0">
                      Other Checks Details
                    </h5>
                  )}
                  {data.other_checks &&
                    Object.entries(data.other_checks).map(([d, obj]) => {
                      if (obj?.fields?.length || obj?.docs?.length) {
                        return (
                          <>
                          {
                            Object.entries(obj?.fields || {}).map(field => {
                            return (
                              <div className="row mt-1">
                                <div className="col-md-3 text-muted">
                                  {field[1].label}
                                </div>
                                <div className="col-md-9 ">{field[1].value}</div>
                              </div>
                            );
                            })
                          }
                          {
                            Object.entries(obj?.docs || {}).map(doc => {
                            return (
                              <div className="row mt-1">
                            {doc[1].label && (
                              <div className="col-md-3 text-muted">
                                {`Document[s] Attached`}
                              </div>
                            )}
                            {doc[1].url?.preview_key && (
                              <a
                                href={doc[1].url?.preview_key}
                                download
                                target="_blank"
                                className="col-md-3 text-primary d-inline-flex mr-3"
                                style={{alignItems: "flex-start"}}
                              >
                                <img
                                  src={DownloadIconBlue}
                                  alt=""
                                  className="mr-1 mt-1"
                                />{" "}
                                <span>{doc[1].label}</span> 
                              </a>
                            )}
                          </div>
                            );
                            })
                          }
                          </>
                        )
                      } else {
                        return <></>
                      }
                    })}
                </div>
              </div>
            </div>
          )}
          {data.authorization_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              {data.authorization_details.label}
            </h5>
          )}
          {data.authorization_details && (
            <div className="row mt-3">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                <div className="row mt-1">
                          { data?.authorization_details?.is_arn_later?.ARN_url!= null ?    <div className="col-md-3 text-muted">
                              Authorization Provided
                              </div>:  <div className="col-md-3 text-muted">{data?.authorization_details?.is_arn_later?.label || ''}</div>}
                  {data.authorization_details &&
                    Object.entries(data.authorization_details).map(
                      ([f, obj]) => {
                        if (obj.ARN_url != null && obj.ARN_url!=='') {
                          return ( 
                              <a
                                href={obj.ARN_url}
                                download
                                target="_blank"
                                className="col-md-3 text-primary d-inline-flex mr-3"
                              >
                                <img
                                  src={DownloadIconBlue}
                                  alt=""
                                  className="mr-1"
                                />{" "}
                                ARN Document
                              </a>
                            
                          );
                        }
                        if(obj.ARN_url == null){
                          return ( 
                           <p>{obj?.label}</p>
                          
                        );
                        }
                      }
                    )}
                    </div>
                  {data?.spoc_details &&
                    Object.entries(data?.spoc_details).map(([f, obj]) => {
                      if (obj?.value != null) {
                        return (
                          <div className="row mt-1">
                            <div className="col-md-3 text-muted">
                              SPOC Details
                            </div>
                            <div className="col-md-9">{obj?.value}</div>
                          </div>
                        );
                      }
                    })} 
                </div>
              </div>
            </div>
          )}
          {/* {data.spoc_details && (
                      <h5 className="fnt-smi-bld mt-3 mb-3">
                        {data.spoc_details.label}
                      </h5>
                    )} */}
                {
                //  data.spoc_details && 
                //   <div className="row mt-3">
                //   <div className="col-md-12">
                //     <div className="common-white-box p-3">
                //     {data.spoc_details &&
                //         Object.entries(data.spoc_details).map(([f, obj]) => {
                //           // console.log('spoc obje....',obj)
                //             return (
                //               <div className="row mt-1">
                //                 {/* <div className="col-md-3 text-muted">
                //                   SPOC Details
                //                 </div> */}
                //                 <div className="col-md-9">{obj.value}</div>
                //               </div>
                //             );
                //         })}
                //     </div>
                //   </div>
                // </div>
              }
          {data.nid_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">{data.nid_details.label}</h5>
          )}
          {data.nid_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.nid_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/nid`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.nid_details &&
                    Object.entries(data.nid_details).map(([f, obj]) => {
                      if (obj.value != "" && obj.url != "") {
                        return (
                          <div className="row mt-1">
                            {obj.value && (
                              <div className="col-md-3 text-muted">
                                {obj.label}
                              </div>
                            )}
                            {obj.value && (
                              <div className="col-md-9">{obj.value}</div>
                            )}
                            {obj.url && (
                              <>
                                <div className="col-md-3 text-muted">
                                  Document(s) Attached
                                </div>
                                <div className="col-md-6">
                                  <a
                                    href={obj.url}
                                    download
                                    target="_blank"
                                    className="text-primary d-inline-flex"
                                  >
                                    <img
                                      src={DownloadIconBlue}
                                      alt=""
                                      className="mr-1"
                                    />{" "}
                                    {obj.label}
                                  </a>
                                </div>
                              </>
                            )}
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          )}

{bankPreview && profilePreviewData?.data?.bank_account_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">{bankPreview.label}</h5>
          )}
          {bankPreview && profilePreviewData?.data?.bank_account_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {bankPreview && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/20`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {bankPreview &&
                    Object.entries(bankPreview).map(([f, obj]) => {
                      if (obj.value != "" && obj.url != "") {
                        return (
                          <div className="row mt-1">
                            {obj.value && (
                              <div className="col-md-3 text-muted">
                                {obj.label}
                              </div>
                            )}
                            {obj.value && (
                              <div className="col-md-9">{obj.value}</div>
                            )}

                                {obj.preview_url &&
                                    Object.entries(obj.preview_url).map(
                                      ([i, url]) => {
                                        if (url != "") {
                                          return (
                                            <>
                                            <div className="col-md-3 text-muted">
                                            Document(s) Attached
                                          </div>
                                            <a
                                              href={url}
                                              download
                                              target="_blank"
                                              className="text-primary d-inline-flex mr-3-pc d-flex-mbl text-truncate pl-3"
                                            >
                                              <img
                                                src={DownloadIconBlue}
                                                alt=""
                                                className="mr-1"
                                              />{" "}
                                              {i}
                                            </a>
                                            </>
                                          );
                                        }
                                      }
                                    )}
                         
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          )}

{data?.visual_document_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">{data?.visual_document_details[0].label}</h5>
          )}
          {data?.visual_document_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data?.visual_document_details[0] && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/21`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data?.visual_document_details &&
                    Object.entries(data?.visual_document_details[0]).map(([f, obj]) => {
                      if (obj.value != "" && obj.url != "") {
                        return (
                          <div className="row mt-1">
                            {obj.value && (
                              <div className="col-md-3 text-muted">
                                {obj.label}
                              </div>
                            )}
                            {obj.value && (
                              <div className="col-md-9">{obj.value}</div>
                            )}
                            {obj.preview_url &&
                                    Object.entries(obj.preview_url).map(
                                      ([i, url]) => {
                  
                                        if (url != "") {
                                          return (
                                            <>
                                         {i=="Visual document 1" ?   <div className="col-md-3 text-muted">
                                            Document(s) Attached
                                          </div> :''}
                                            <a
                                              href={url}
                                              download
                                              target="_blank"
                                              className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                            >
                                              <img
                                                src={DownloadIconBlue}
                                                alt=""
                                                className="mr-1"
                                              />{" "}
                                              {i}
                                            </a>
                                            </>
                                          );
                                        }
                                      }
                                    )}
                            {/* {obj.url && (
                              <>
                                <div className="col-md-3 text-muted">
                                  Document(s) Attached
                                </div>
                                <div className="col-md-6">
                                  <a
                                    href={obj.url}
                                    download
                                    target="_blank"
                                    className="text-primary d-inline-flex"
                                  >
                                    <img
                                      src={DownloadIconBlue}
                                      alt=""
                                      className="mr-1"
                                    />{" "}
                                    {obj.label}
                                  </a>
                                </div>
                              </>
                            )} */}
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          )} 

          {data.eAadhaar_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              {data.eAadhaar_details.label}
            </h5>
          )}
          {data.eAadhaar_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.eAadhaar_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/eaadhar`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.eAadhaar_details &&
                    Object.entries(data.eAadhaar_details).map(([f, obj]) => {
                      if (obj.value != "" && obj.url != "") {
                        return (
                          <div className="row mt-1">
                            {obj.value && (
                              <div className="col-md-3 text-muted">
                                {obj.label}
                              </div>
                            )}
                            {obj.value && (
                              <div className="col-md-9">{obj.value}</div>
                            )}
                            {obj.url && (
                              <a
                                href={obj.url}
                                download
                                target="_blank"
                                className="col-md-3 text-primary d-inline-flex mr-3"
                              >
                                <img
                                  src={DownloadIconBlue}
                                  alt=""
                                  className="mr-1"
                                />{" "}
                                {obj.label}
                              </a>
                            )}
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          )}

          {data.address && (
            <>
              <h5 className="fnt-smi-bld mt-3 mb-3">Address Details</h5>
              <div className="row">
                <div className="col-md-12">
                  <div className="common-white-box p-3 mb-4">
                    <div className="d-flex justify-content-between">
                      <h5></h5>
                      <Link
                        to={`/case-initiation/check-detail/${reference}/2`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    </div>
                    {data.current_address && (
                      <div className="row mt-1">
                        <div className="col-md-12 mt-1 fnt-smi-bld">
                          Current Address
                        </div>
                      </div>
                    )}
                    {data.current_address &&
                      Object.entries(data.current_address).map(
                        ([key, index]) => {
                          if (index.value != "") {
                            return (
                              <div className="row mt-1">
                                {index.label && (
                                  <div className="col-md-3 text-muted">
                                    {index.label}
                                  </div>
                                )}
                                {index.value && (
                                  <div className="col-md-9 ">{index.value}</div>
                                )}
                                <div className="col-md-9 ">
                                  {index.preview_url &&
                                    Object.entries(index.preview_url).map(
                                      ([i, url]) => {
                                        if (url != "") {
                                          return (
                                            <a
                                              href={url}
                                              download
                                              target="_blank"
                                              className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                            >
                                              <img
                                                src={DownloadIconBlue}
                                                alt=""
                                                className="mr-1"
                                              />{" "}
                                              {i}
                                            </a>
                                          );
                                        }
                                      }
                                    )}
                                </div>
                              </div>
                            );
                          }
                        }
                      )}
                    {data.current_address && <hr />}
                    {data.permanent_address && (
                      <div className="row mt-1">
                        <div className="col-md-12 mt-1 fnt-smi-bld">
                          Permanent Address
                        </div>
                      </div>
                    )}
                    {data.permanent_address &&
                      Object.entries(data.permanent_address).map(
                        ([key, index]) => {
                          if (index.value != "") {
                            return (
                              <div className="row mt-1">
                                {index.label && (
                                  <div className="col-md-3 text-muted">
                                    {index.label}
                                  </div>
                                )}
                                {index.value && (
                                  <div className="col-md-9 ">{index.value}</div>
                                )}
                                <div className="col-md-9 ">
                                  {index.preview_url &&
                                    Object.entries(index.preview_url).map(
                                      ([i, url]) => {
                                        if (url != "") {
                                          return (
                                            <a
                                              href={url}
                                              download
                                              target="_blank"
                                              className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                            >
                                              <img
                                                src={DownloadIconBlue}
                                                alt=""
                                                className="mr-1"
                                              />{" "}
                                              {i}
                                            </a>
                                          );
                                        }
                                      }
                                    )}
                                </div>
                              </div>
                            );
                          }
                        }
                      )}
                    {data.permanent_address && <hr />}
                    {data.Addresses &&
                      Object.entries(data.Addresses).map(([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3 text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              if (url != "") {
                                                return (
                                                  <a
                                                    href={url}
                                                    download
                                                    target="_blank"
                                                    className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                  >
                                                    <img
                                                      src={DownloadIconBlue}
                                                      alt=""
                                                      className="mr-1"
                                                    />{" "}
                                                    {i}
                                                  </a>
                                                );
                                              }
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </>
          )}

          {data.business_address && (
            <>
              <h5 className="fnt-smi-bld mt-3 mb-3">
                Business Address Details
              </h5>
              <div className="row">
                <div className="col-md-12">
                  <div className="common-white-box p-3 mb-4">
                    <div className="d-flex justify-content-between">
                      <h5></h5>
                      <Link
                        to={`/case-initiation/check-detail/${reference}/18`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    </div>
                    {data.business_address &&
                      Object.entries(data.business_address).map(([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3 text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              if (url != "") {
                                                return (
                                                  <a
                                                    href={url}
                                                    download
                                                    target="_blank"
                                                    className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                  >
                                                    <img
                                                      src={DownloadIconBlue}
                                                      alt=""
                                                      className="mr-1"
                                                    />{" "}
                                                    {i}
                                                  </a>
                                                );
                                              }
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </>
          )}

          {data.education_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">Education Details</h5>
          )}
          {data.education_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {!!(data.education_details && data?.digilocker_journey) && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/3/uploadDigi`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                    {!!(data.education_details && !data?.digilocker_journey) && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/3`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.education_details1 && (
                    <div className="row mt-1">
                      {data.education_details1.is_campus_hire && (
                        <div className="col-md-3  fnt-smi-bld">
                          {data.education_details1.is_campus_hire.label}
                        </div>
                      )}
                      {data.education_details1.is_campus_hire && (
                        <div className="col-md-3 ">
                          {data.education_details1.is_campus_hire.value}
                        </div>
                      )}
                    </div>
                  )}
                  {data.education_details &&
                    Object.entries(data.education_details).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {obj.label}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              // console.log(index)
          
                              if(index.value != "" && key=='digilocker'){
                                for (let i = 0; i < index.length; i++){
                                  // return (
                                  //   <div className="row mt-1">
                                  //     {index[i].label && (
                                  //       <div className="col-md-3  text-muted">
                                  //         {index[i].label}
                                  //       </div>
                                  //     )}
                                  //     {index[i].value && (
                                  //       <div className="col-md-9 ">
                                  //         {index[i].value}
                                  //       </div>
                                  //     )}
                                  //   </div>
                                  // );
                                }
                               
                              }
                              if (index.value != "" && key!='digilocker') {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    <div className="col-md-9 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            if (url != "") {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                              
                            })}
                          <hr />
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {data.education_gap && (
            <div className="row mt-15">
                <div className="col-md-12">
                  <div className="common-white-box p-3">
                    <div className="d-flex justify-content-between">
                      <h5 className="fnt-smi-bld">
                         Education Gap </h5>
                         <h5 className="fnt-smi-bld"></h5>
                      </div>
                         <div className="row">
                          <div className="col-md-12">
                         {data.education_gap && Object.entries(data.education_gap).map(([w, index]) => {
                          return (
                            <>
                                {index.gap_tenure && (
                                  <h6 className="fnt-smi-bld">
                                    {index.gap_tenure.value}
                                  </h6>
                                )}
                                {index.gap_label && (
                                  <button className="btn btn-orange mt-2">
                                    {index.gap_label.label}
                                  </button>
                                )}
                                 <div className="row mt-3">
                                  <div className="col-md-6 d-flex">
                                  {index.gap_reason && (
                                    <label className="fnt-smi-bld text-muted">
                                      Reason
                                    </label>
                                  )}
                                  {index.gap_reason && (
                                    <div className="col-md-9 ">
                                    {index.gap_reason.value}
                                  </div>
                                  )}
                                  
                                </div>
                               </div>
                           </> );
                          })}
                        </div>
                    </div>
                </div>
            </div>
           </div>
          )}
          {(data.employment_details || data.current_employment || data.previous_employment)&& (
            <h5 className="fnt-smi-bld mt-3 mb-3">Employment Details</h5>
          )}
          {(data.employment_details || data.current_employment || data.previous_employment) && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {(data.employment_details || data.current_employment || data.previous_employment) && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/4`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.employment_details &&
                    Object.entries(data.employment_details).map(([d, obj]) => {
                      if (obj.value != "") {
                        return (
                          <div className="row mt-1">
                            <div className="col-md-3 text-muted">
                              {obj.label}
                            </div>
                            <div className="col-md-9 ">{obj.value}</div>
                          </div>
                        );
                      }
                    })}
                 {data.current_employment &&
                    Object.entries(data.current_employment).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {obj.label}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.label1 && (
                                      <div className="col-md-3 fnt-smi-bld">
                                        {index.label1}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    {/* {
                                      key == "company_details" && (
                                        <div className="col-md-9 fnt-smi-bld">
                                          {`Company Details`}
                                        </div>
                                      )
                                    } */}
                                    {key == "company_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {/* {
                                      key == "job_details" && (
                                        <div className="col-md-9 fnt-smi-bld">
                                          {`Job Details`}
                                        </div>
                                      )
                                    } */}
                                    {key == "job_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "form16_details" &&
                                      Object.entries(index).map(([i, indd]) => {
                                        if (indd.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {indd.label}
                                                </div>
                                                {indd.value && (
                                                  <div className="col-md-9 ">
                                                    {indd.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "hr_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "manager_details" &&
                                      Object.entries(index).map(([i, ind]) => {
                                        if (ind.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind.label}
                                                </div>
                                                {ind.value && (
                                                  <div className="col-md-9 ">
                                                    {ind.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "manager_details1" &&
                                      Object.entries(index).map(([i, ind2]) => {
                                        if (ind2.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind2.label}
                                                </div>
                                                {ind2.value && (
                                                  <div className="col-md-9 ">
                                                    {ind2.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    <div className="col-md-9 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            if (url != "") {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          <hr />
                        </>
                      );
                    })}
                  {data.previous_employment &&
                    Object.entries(data.previous_employment).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {obj.label}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.label1 && (
                                      <div className="col-md-3 fnt-smi-bld">
                                        {index.label1}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                     {/* {
                                      key == "company_details" && (
                                        <div className="col-md-9 fnt-smi-bld">
                                          {`Company Details`}
                                        </div>
                                      )
                                    } */}
                                    {key == "company_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {/* {
                                      key == "job_details" && (
                                        <div className="col-md-9 fnt-smi-bld">
                                          {`Job Details`}
                                        </div>
                                      )
                                    } */}
                                    {key == "job_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "form16_details" &&
                                      Object.entries(index).map(([i, indd]) => {
                                        if (indd.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {indd.label}
                                                </div>
                                                {indd.value && (
                                                  <div className="col-md-9 ">
                                                    {indd.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "hr_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "manager_details" &&
                                      Object.entries(index).map(([i, ind]) => {
                                        if (ind.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind.label}
                                                </div>
                                                {ind.value && (
                                                  <div className="col-md-3 ">
                                                    {ind.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "manager_details1" &&
                                      Object.entries(index).map(([i, ind2]) => {
                                        if (ind2.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind2.label}
                                                </div>
                                                {ind2.value && (
                                                  <div className="col-md-9 ">
                                                    {ind2.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    <div className="col-md-9 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            if (url != "") {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          <hr />
                        </>
                      );
                    })}
                  {data.instant_current_employment &&
                    Object.entries(data.instant_current_employment).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.label1 && (
                                        <div className="col-md-3 fnt-smi-bld">
                                          {index.label1}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      {key == "form16_details" &&
                                        Object.entries(index).map(
                                          ([i, indd]) => {
                                            if (indd.value != "") {
                                              return (
                                                <div className="col-md-12 ">
                                                  <div className="row mt-1">
                                                    <div className="col-md-3  text-muted">
                                                      {indd.label}
                                                    </div>
                                                    {indd.value && (
                                                      <div className="col-md-9 ">
                                                        {indd.value}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                        )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              if (url != "") {
                                                return (
                                                  <a
                                                    href={url}
                                                    download
                                                    target="_blank"
                                                    className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                  >
                                                    <img
                                                      src={DownloadIconBlue}
                                                      alt=""
                                                      className="mr-1"
                                                    />{" "}
                                                    {i}
                                                  </a>
                                                );
                                              }
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      }
                    )}
                  {data.instant_previous_employment &&
                    Object.entries(data.instant_previous_employment).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.label1 && (
                                        <div className="col-md-3 fnt-smi-bld">
                                          {index.label1}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      {key == "form16_details" &&
                                        Object.entries(index).map(
                                          ([i, ind1]) => {
                                            if (ind1.value != "") {
                                              return (
                                                <div className="col-md-12 ">
                                                  <div className="row mt-1">
                                                    <div className="col-md-3  text-muted">
                                                      {ind1.label}
                                                    </div>
                                                    {ind1.value && (
                                                      <div className="col-md-9 ">
                                                        {ind1.value}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                        )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              if (url != "") {
                                                return (
                                                  <a
                                                    href={url}
                                                    download
                                                    target="_blank"
                                                    className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                  >
                                                    <img
                                                      src={DownloadIconBlue}
                                                      alt=""
                                                      className="mr-1"
                                                    />{" "}
                                                    {i}
                                                  </a>
                                                );
                                              }
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.employment_gap && (
            <div className="row mt-15">
                <div className="col-md-12">
                  <div className="common-white-box p-3">
                    <div className="d-flex justify-content-between">
                      <h5 className="fnt-smi-bld">
                         Employment Gap </h5>
                         <h5 className="fnt-smi-bld"></h5>
                      </div>
                         <div className="row">
                          <div className="col-md-12">
                         {data.employment_gap && Object.entries(data.employment_gap).map(([w, index]) => {
                          return (
                            <>
                                {index.gap_tenure && (
                                  <h6 className="fnt-smi-bld">
                                    {index.gap_tenure.value}
                                  </h6>
                                )}
                                {index.gap_label && (
                                  <button className="btn btn-orange mt-2">
                                    {index.gap_label.label}
                                  </button>
                                )}
                                 <div className="row mt-3">
                                  <div className="col-md-6 d-flex">
                                  {index.gap_reason && (
                                    <label className="fnt-smi-bld text-muted">
                                      Reason
                                    </label>
                                  )}
                                  {index.gap_reason && (
                                    <div className="col-md-9 ">
                                      {index.gap_reason.value}
                                    </div>
                                  )}
                                  
                                </div>
                               </div>
                           </> );
                          })}
                        </div>
                    </div>
                </div>
            </div>
          </div>
          )}  
          {data.edu_to_employment_gap && (
            <div className="row mt-15">
                <div className="col-md-12">
                  <div className="common-white-box p-3">
                    <div className="d-flex justify-content-between">
                      <h5 className="fnt-smi-bld">
                         Education to Employment Gap </h5>
                         <h5 className="fnt-smi-bld"></h5>
                      </div>
                         <div className="row">
                          <div className="col-md-12">
                         {data.edu_to_employment_gap && Object.entries(data.edu_to_employment_gap).map(([w, index]) => {
                          return (
                            <>
                                {index.gap_tenure && (
                                  <h6 className="fnt-smi-bld">
                                    {index.gap_tenure.value}
                                  </h6>
                                )}
                                {index.gap_label && (
                                  <button className="btn btn-orange mt-2">
                                    {index.gap_label.label}
                                  </button>
                                )}
                                 <div className="row mt-3">
                                  <div className="col-md-6 d-flex">
                                  {index.gap_reason && (
                                    <label className="fnt-smi-bld text-muted">
                                      Reason
                                    </label>
                                  )}
                                  {index.gap_reason && (
                                    <div className="col-md-9 ">
                                    {index.gap_reason.value}
                                  </div>
                                  )}
                                  
                                </div>
                               </div>
                           </> );
                          })}
                        </div>
                    </div>
                </div>
            </div>
          </div>
          )}
          {(data?.employment_via_uan)&& (
            <h5 className="fnt-smi-bld mt-3 mb-3">Employment Via UAN Details</h5>
          )}
          {(data?.employment_via_uan) && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3">
                  <div className="d-flex justify-content-between">
                  <h5>Employment Details</h5>
                    {(data.employment_via_uan && !(data.employment_details || data.current_employment || data.previous_employment)) && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/24`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.employment_via_uan &&
                    Object.entries(data.employment_via_uan).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {obj.label}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.label1 && (
                                      <div className="col-md-3 fnt-smi-bld">
                                        {index.label1}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    {/* {
                                      key == "company_details" && (
                                        <div className="col-md-9 fnt-smi-bld">
                                          {`Company Details`}
                                        </div>
                                      )
                                    } */}
                                    {key == "company_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {/* {
                                      key == "job_details" && (
                                        <div className="col-md-9 fnt-smi-bld">
                                          {`Job Details`}
                                        </div>
                                      )
                                    } */}
                                    {key == "job_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "form16_details" &&
                                      Object.entries(index).map(([i, indd]) => {
                                        if (indd.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {indd.label}
                                                </div>
                                                {indd.value && (
                                                  <div className="col-md-9 ">
                                                    {indd.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "hr_details" &&
                                      Object.entries(index).map(([i, ind1]) => {
                                        if (ind1.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind1.label}
                                                </div>
                                                {ind1.value && (
                                                  <div className="col-md-9 ">
                                                    {ind1.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "manager_details" &&
                                      Object.entries(index).map(([i, ind]) => {
                                        if (ind.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind.label}
                                                </div>
                                                {ind.value && (
                                                  <div className="col-md-9 ">
                                                    {ind.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    {key == "manager_details1" &&
                                      Object.entries(index).map(([i, ind2]) => {
                                        if (ind2.value != "") {
                                          return (
                                            <div className="col-md-12 ">
                                              <div className="row mt-1">
                                                <div className="col-md-3  text-muted">
                                                  {ind2.label}
                                                </div>
                                                {ind2.value && (
                                                  <div className="col-md-9 ">
                                                    {ind2.value}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      })}
                                    <div className="col-md-9 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            if (url != "") {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          <hr />
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {data.professional_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">Professional Details</h5>
          )}
          {data.professional_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.professional_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/5`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.current_reference_details &&
                    Object.entries(data.current_reference_details).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      {key == "reference" &&
                                        Object.entries(index).map(
                                          ([i, ind]) => {
                                            return (
                                              <div className="col-md-12 ">
                                                <div className="row mt-1">
                                                  <div className="col-md-12 mt-1">
                                                    {ind.label}
                                                  </div>
                                                </div>
                                                {ind &&
                                                  Object.entries(ind).map(
                                                    ([key, index]) => {
                                                      if (index.value != "") {
                                                        return (
                                                          <div className="row mt-1">
                                                            {index.label && (
                                                              <div className="col-md-3  text-muted">
                                                                {index.label}
                                                              </div>
                                                            )}
                                                            {index.value && (
                                                              <div className="col-md-9 ">
                                                                {index.value}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                              </div>
                                            );
                                          }
                                        )}
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      }
                    )}
                  {data.previous_reference_details &&
                    Object.entries(data.previous_reference_details).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      {key == "reference" &&
                                        Object.entries(index).map(
                                          ([i, ind]) => {
                                            return (
                                              <div className="col-md-12">
                                                <div className="row mt-1">
                                                  <div className="col-md-12 mt-1">
                                                    {ind.label}
                                                  </div>
                                                </div>
                                                {ind &&
                                                  Object.entries(ind).map(
                                                    ([key, index]) => {
                                                      if (index.value != "") {
                                                        return (
                                                          <div className="row mt-1">
                                                            {index.label && (
                                                              <div className="col-md-3  text-muted">
                                                                {index.label}
                                                              </div>
                                                            )}
                                                            {index.value && (
                                                              <div className="col-md-9 ">
                                                                {index.value}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                              </div>
                                            );
                                          }
                                        )}
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.personal_reference_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Personal Reference Details
            </h5>
          )}
          {data.personal_reference_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.personal_reference_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/6`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.personal_reference_details &&
                    Object.entries(data.personal_reference_details).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      {key == "reference" &&
                                        Object.entries(index).map(
                                          ([i, ind]) => {
                                            return (
                                              <div className="col-md-12">
                                                <div className="row mt-1">
                                                  <div className="col-md-12 mt-1">
                                                    {ind.label}
                                                  </div>
                                                </div>
                                                {ind &&
                                                  Object.entries(ind).map(
                                                    ([key, index]) => {
                                                      if (index.value != "") {
                                                        return (
                                                          <div className="row mt-1">
                                                            {index.label && (
                                                              <div className="col-md-3  text-muted">
                                                                {index.label}
                                                              </div>
                                                            )}
                                                            {index.value && (
                                                              <div className="col-md-9 ">
                                                                {index.value}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                              </div>
                                            );
                                          }
                                        )}
                                    </div>
                                  );
                                }
                              })}
                            <hr />
                          </>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.drug_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">Drug Details</h5>
          )}
          {data.drug_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.drug_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/10`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.drug_details &&
                    Object.entries(data.drug_details).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {obj.label}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    <div className="col-md-9 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            return (
                                              <a
                                                href={url}
                                                download
                                                target="_blank"
                                                className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                              >
                                                <img
                                                  src={DownloadIconBlue}
                                                  alt=""
                                                  className="mr-1"
                                                />{" "}
                                                {i}
                                              </a>
                                            );
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          <hr />
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {data.pv_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">Police Verification Details</h5>
          )}
          {data.pv_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.pv_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/7`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.pv_details &&
                    Object.entries(data.pv_details).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {obj.label}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    {key == "reference" &&
                                        Object.entries(index).map(
                                          ([i, ind]) => {
                                            return (
                                              <div className="col-md-12">
                                                <div className="row mt-1">
                                                  <div className="col-md-12 mt-1">
                                                    {ind.label}
                                                  </div>
                                                </div>
                                                {ind &&
                                                  Object.entries(ind).map(
                                                    ([key, index]) => {
                                                      if (index.value != "") {
                                                        return (
                                                          <div className="row mt-1">
                                                            {index.label && (
                                                              <div className="col-md-3  text-muted">
                                                                {index.label}
                                                              </div>
                                                            )}
                                                            {index.value && (
                                                              <div className="col-md-9 ">
                                                                {index.value}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                      }
                                                    }
                                                  )}
                                              </div>
                                            );
                                          }
                                        )}
                                    <div className="col-md-9 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            if (url != "") {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i.replace(/^[0-9]+/, '').replace(/[0-9]+$/, '')}
                                                </a>
                                              );
                                            }
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          <hr />
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {data.prof_license_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Professional License Details
            </h5>
          )}
          {data.prof_license_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.prof_license_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/12`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.prof_license_details &&
                    Object.entries(data.prof_license_details).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                          </>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.doc_registration_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Doctor(s) Registration Details
            </h5>
          )}
          {data.doc_registration_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.doc_registration_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/13`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.doc_registration_details &&
                    Object.entries(data.doc_registration_details).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                          </>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.eligibility_work_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Eligibility To Work Details
            </h5>
          )}
          {data.eligibility_work_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.eligibility_work_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/14`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.eligibility_work_details &&
                    Object.entries(data.eligibility_work_details).map(
                      ([i, obj]) => {
                        return (
                          <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {obj.label}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj).map(([key, index]) => {
                                if (index.value != "") {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              return (
                                                <a
                                                  href={url}
                                                  download
                                                  target="_blank"
                                                  className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                >
                                                  <img
                                                    src={DownloadIconBlue}
                                                    alt=""
                                                    className="mr-1"
                                                  />{" "}
                                                  {i}
                                                </a>
                                              );
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                          </>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.scotland_disclosure_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Scotland Disclosure Details
            </h5>
          )}
          {data.scotland_disclosure_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.scotland_disclosure_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/15`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.scotland_disclosure_details &&
                    Object.entries(data.scotland_disclosure_details).map(
                      ([key, index]) => {
                        if (index.value != "") {
                          return (
                            <div className="row mt-1">
                              {index.label && (
                                <div className="col-md-3  text-muted">
                                  {index.label}
                                </div>
                              )}
                              {index.value && (
                                <div className="col-md-9 ">{index.value}</div>
                              )}
                              <div className="col-md-9 ">
                                {index.preview_url &&
                                  Object.entries(index.preview_url).map(
                                    ([i, url]) => {
                                      if (url != "") {
                                        return (
                                          <a
                                            href={url}
                                            download
                                            target="_blank"
                                            className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                          >
                                            <img
                                              src={DownloadIconBlue}
                                              alt=""
                                              className="mr-1"
                                            />{" "}
                                            {i}
                                          </a>
                                        );
                                      }
                                    }
                                  )}
                              </div>
                            </div>
                          );
                        }
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {data.other_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">Others Details</h5>
          )}
          {data.other_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.other_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/9`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.other_details &&
                    Object.entries(data.other_details.data).map(([i, obj]) => {
                      return (
                        <>
                          <div className="row mt-1">
                            <div className="col-md-12 mt-1 fnt-smi-bld">
                              {i}
                            </div>
                          </div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                  </div>
                                );
                              }
                            })}
                          <hr />
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {data.employment_uan_details
 && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              {data.employment_uan_details
.label}
            </h5>
          )}
          {data.employment_uan_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.employment_uan_details && (
                      <Link to={`/case-initiation/check-detail/${reference}/22`} className="text-primary">
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.employment_uan_details.uan_data &&
                    Object.entries(data.employment_uan_details.uan_data).map(([i, obj]) => {
                      return (
                        <div className="">

                          <div className="row mt-1">
                                      {obj.label && (
                                        <div className="col-md-3  text-muted">
                                          {obj.label}
                                        </div>
                                      )}
                                      {obj.value && (
                                        <div className="col-md-9 ">
                                          {obj.value}
                                        </div>
                                      )}
                                      </div>
                        </div>
                      );
                    })}
                    {data.employment_uan_details.value && <div className="row mt-1">
                        <div className="col-md-12 mt-1 fnt-smi-bld">
                          Employment History
                        </div>
                      </div>}
                    {data.employment_uan_details.value &&
                    Object.entries(data.employment_uan_details.value).map(([i, obj]) => {
                      return (
                        <div className="">

                          <div className="row mt-2">
                          {data.employment_uan_details.value[i] &&
                          Object.entries(data.employment_uan_details.value[i]).map(([i, obj]) => {return(
                            <>{obj.label && (
                              <div className="col-md-3  text-muted">
                                {obj.label}
                              </div>
                            )}
                            {obj.label =="Salary Slip"?
                              <div className="col-md-9 ">
                              {obj.value?.map((object,i)=>{return(<a
                                              href={object.preview_key}
                                              download
                                              target="_blank"
                                              className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                            >
                                              <img
                                                src={DownloadIconBlue}
                                                alt=""
                                                className="mr-1"
                                              />{" "}
                                              salary slip {i+1}
                                            </a>)})}
                            </div>
                            
                            :
                              <div className="col-md-9 ">
                                {obj.value}
                              </div>
                            }
                            </>

                          )})}
                                      
                                      {console.log(obj)}
                                      </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {data.SOF_documents && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              {data.SOF_documents.label}
            </h5>
          )}
          {data.SOF_documents && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.SOF_documents && (
                      <Link to="" className="text-primary">
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.SOF_documents &&
                    Object.entries(data.SOF_documents).map(([i, obj]) => {
                      return (
                        <div className="">
                          <div className="col-md-12 mt-1">{obj.label}</div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    <div className="col-md-12 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            return (
                                              <a
                                                href={url}
                                                download
                                                target="_blank"
                                                className="text-primary d-inline-flex mr-3"
                                              >
                                                <img
                                                  src={DownloadIconBlue}
                                                  alt=""
                                                  className="mr-1"
                                                />{" "}
                                                {i}
                                              </a>
                                            );
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
          {/* Declaration Details */}
          {data.declaration_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Declaration Details
            </h5>
          )}
          {data.declaration_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.declaration_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/50`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.declaration_details &&
                    Object.entries(data.declaration_details).map(
                      ([key, index]) => {
                        if (index.value != "") {
                          return (
                            <div className="row mt-1">
                              {index.label && (
                                <div className="col-md-3  text-muted">
                                  {index.label}
                                </div>
                              )}
                              {index.value && (
                                <div className="col-md-9 ">{index.value}</div>
                              )}
                              <div className="col-md-9 ">
                                {index.preview_url &&
                                  Object.entries(index.preview_url).map(
                                    ([i, url]) => {
                                      if (url != "") {
                                        return (
                                          <a
                                            href={url}
                                            download
                                            target="_blank"
                                            className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                          >
                                            <img
                                              src={DownloadIconBlue}
                                              alt=""
                                              className="mr-1"
                                            />{" "}
                                            {i}
                                          </a>
                                        );
                                      }
                                    }
                                  )}
                              </div>
                            </div>
                          );
                        }
                      }
                    )}
                </div>
              </div>
            </div>
          )}
          {/* form 16 details */}
          {data.form_16_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Form 16 Details
            </h5>
          )}
          {data.form_16_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.form_16_details && (
                      <Link
                        to={`/case-initiation/check-detail/${reference}/23`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.form_16_details &&
                    Object.values(data?.form_16_details)?.map((item, key) => {
                      
                      return(
                        <>
                        <div style={{fontWeight: 500}}>Form 16 Verification {key+1}</div>
                        {Object.entries(item).map(
    
                          ([key, index]) => {
                            if (index.value != "") {
                              return (
                                
                                <div className="row mt-1">
                                  {index.label && (
                                    <div className="col-md-3  text-muted">
                                      {index.label}
                                    </div>
                                  )}
                                  {index.value && (
                                    <div className="col-md-9 ">{index.value}</div>
                                  )}
                                  <div className="col-md-9 ">
                                    {index.preview_url &&
                                      Object.entries(index.preview_url).map(
                                        ([i, url]) => {
                                          if (url != "") {
                                            return (
                                              <a
                                                href={url}
                                                download
                                                target="_blank"
                                                className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                              >
                                                <img
                                                  src={DownloadIconBlue}
                                                  alt=""
                                                  className="mr-1"
                                                />{" "}
                                                {i}
                                              </a>
                                            );
                                          }
                                        }
                                      )}
                                  </div>
                                </div>
                              );
                            }
                          }
                        )}
                        </>
                      )
                    })
                    }
                </div>
              </div>
            </div>
          )}
          </>
           :
           <></>
        }
        { 
           isOnboarding ?
           <>
          {/* onboarding form details */}
          {data.onboarding_details && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              Onboarding Details
            </h5>
          )}
          {data.onboarding_details && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.onboarding_details && (
                      <Link
                        // to={`/onbordingDetailsInstaform/`}
                        to={`/case-initiation/check-detail/${reference}/11/`}
                        className="text-primary"
                      >
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data?.onboarding_details && 
                    Object.entries(data?.onboarding_details?.tab_details).map(([heading, item],index) => {
                      return(
                        <>
                        <div className="fnt-smi-bld" style={{fontSize: 'x-large'}}>{heading}</div>
                      {Object.entries(item).map(([i, obj]) => {
                        return (
                          <>
                          {i != 'PF Nominee Details' && i != 'Gratuity Nominee Details' && i != 'EPS Nominee Details' && i != 'GROUP PERSONAL ACCIDENT INSURANCE' && i != 'GROUP TERM LIFE INSURANCE' ?
                            <>
                            <div className="row mt-1">
                              <div className="col-md-12 mt-1 fnt-smi-bld">
                                {i}
                              </div>
                            </div>
                            {obj &&
                              Object.entries(obj.field_details).map(([key, index]) => {
                                // console.log(index)

                                if (index.value != "" ) {
                                  return (
                                    <div className="row mt-1">
                                      {index.label && (
                                        <div className="col-md-3  text-muted">
                                          {index.label}
                                        </div>
                                      )}
                                      {index.value && (
                                        <div className="col-md-9 ">
                                          {index.value}
                                        </div>
                                      )}
                                      <div className="col-md-9 ">
                                        {index.preview_url &&
                                          Object.entries(index.preview_url).map(
                                            ([i, url]) => {
                                              if (url != "") {
                                                return (
                                                  <a
                                                    href={url}
                                                    download
                                                    target="_blank"
                                                    className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                  >
                                                    <img
                                                      src={DownloadIconBlue}
                                                      alt=""
                                                      className="mr-1"
                                                    />{" "}
                                                    {i}
                                                  </a>
                                                );
                                              }
                                            }
                                          )}
                                      </div>
                                    </div>
                                  );
                                }
                               
                              })}
                            <hr />
                            </>
                            :
                            ''
                            } 
                          </>
                        );
                      })}
                      </>
                    )
                    })
                  }
                  { data?.onboarding_details && Object.entries(data?.onboarding_details?.nominee_array).length > 0 &&
                    <div className="col-md-12 mt-1 pl-0 fnt-smi-bld" style={{fontSize: 'x-large'}}>
                    Nominee Details
                    </div>}
                  {data?.onboarding_details && 
                    Object.entries(data?.onboarding_details?.nominee_array).map(([key, item],index) => {
                      console.log(key, 'keyyy');
                      
                      return(
                        <>
                        {/* <div className="fnt-smi-bld" style={{fontSize: 'x-large'}}>{key}</div> */}
                        
                        <div className="row mt-1">
                        
                                {Object.entries(data?.onboarding_details?.tab_array).map(([name, id]) => { 
                                  return( 
                                    <div className="col-md-12 mt-1 fnt-smi-bld" style={{fontSize: 'x-large'}}>
                                    {id == key ? NomineeNameMapping[name] : ''}
                                  </div>
                                    )  
                                })}
                            </div>
                      {data?.onboarding_details?.tab_array?.[onboardingAdditionalName] && 
                       key == data?.onboarding_details?.tab_array?.[onboardingAdditionalName] ?
                       
                       Object.entries(item).map(([header,nom]) => {
                          
                        console.log(nom, 'nom')
                        return(
                        <>  
                        <div className="col-md-12 mt-1 ml-0 pl-0 fnt-smi-bld">
                            {header == 'personal' ? '1) Group Personal Accident Insurance' : header == 'group' ? '2) Group Term Life Insurance' : ''}
                          </div>
                        {nom.map((obj,idx) => {
                          console.log(obj)
                          return (
                            <>
                              <> 
                              <div className="" style={{fontWeight: "bold"}}>Nominee {idx+1}</div>                           
                              {obj &&
                                obj.map((index) => {
                                  console.log(index, 'nomm')
                                  {
                                  if (index.value != "" ) {
                                    return (
                                      <div className="row mt-1">
                                        {index.label && (
                                          <div className="col-md-3  text-muted">
                                            {index.label}
                                          </div>
                                        )}
                                        {index.value && (
                                          <div className="col-md-9 ">
                                            {index.value}
                                          </div>
                                        )}
                                        <div className="col-md-9 ">
                                          {index.preview_url &&
                                            Object.entries(index.preview_url).map(
                                              ([i, url]) => {
                                                if (url != "") {
                                                  return (
                                                    <a
                                                      href={url}
                                                      download
                                                      target="_blank"
                                                      className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                    >
                                                      <img
                                                        src={DownloadIconBlue}
                                                        alt=""
                                                        className="mr-1"
                                                      />{" "}
                                                      {i}
                                                    </a>
                                                  );
                                                }
                                              }
                                            )}
                                        </div>
                                      </div>
                                    );
                                  }
  
                                // })
                              }
                                 
                                })}
                              </>
                            {/* )    */}
                            {/* <hr /> */}
                            </>
                          );
                        })
                        }
                        </>
                        )
                      })
                      :
                      (
                        key != data?.onboarding_details?.tab_array?.[onboardingAdditionalName] &&
                        item?.map((obj,idx) => {
                          console.log(key , 'key', item)
                          return (
                            <>
                            {/* (Object.values(data?.onboarding_details?.tab_array)[index] == 'PF Nominee Details' || Object.values(data?.onboarding_details?.tab_array)[index] == 'Gratuity Nominee Details' || Object.values(data?.onboarding_details?.tab_array)[index] == 'EPS Nominee Details' && */}
                              <>
                              <div className="" style={{fontWeight: "bold"}}>Nominee {idx+1}</div>
                              {obj &&
                                obj.map((index) => {
                                  {
                                    // i.map((index) => {
  
                                  
                                  // console.log(index)
                                  if (index.value != "" ) {
                                    return (
                                      <div className="row mt-1">
                                        {index.label && (
                                          <div className="col-md-3  text-muted">
                                            {index.label}
                                          </div>
                                        )}
                                        {index.value && (
                                          <div className="col-md-9 ">
                                            {index.value}
                                          </div>
                                        )}
                                        <div className="col-md-9 ">
                                          {index.preview_url &&
                                            Object.entries(index.preview_url).map(
                                              ([i, url]) => {
                                                if (url != "") {
                                                  return (
                                                    <a
                                                      href={url}
                                                      download
                                                      target="_blank"
                                                      className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                                                    >
                                                      <img
                                                        src={DownloadIconBlue}
                                                        alt=""
                                                        className="mr-1"
                                                      />{" "}
                                                      {i}
                                                    </a>
                                                  );
                                                }
                                              }
                                            )}
                                        </div>
                                      </div>
                                    );
                                  }
  
                                // })
                              }
                                 
                                })}
                              </>
                            {/* )    */}
                            {/* <hr /> */}
                            </>
                          );
                        
                        })
                      )
                      
                      // item.map((obj) => {
                      //   return (
                      //     <>
                      //       <>                            
                      //       {obj &&
                      //         obj.map((index) => {
                      //           {
                      //           if (index.value != "" ) {
                      //             return (
                      //               <div className="row mt-1">
                      //                 {index.label && (
                      //                   <div className="col-md-3  text-muted">
                      //                     {index.label}
                      //                   </div>
                      //                 )}
                      //                 {index.value && (
                      //                   <div className="col-md-9 ">
                      //                     {index.value}
                      //                   </div>
                      //                 )}
                      //                 <div className="col-md-9 ">
                      //                   {index.preview_url &&
                      //                     Object.entries(index.preview_url).map(
                      //                       ([i, url]) => {
                      //                         if (url != "") {
                      //                           return (
                      //                             <a
                      //                               href={url}
                      //                               download
                      //                               target="_blank"
                      //                               className="text-primary d-inline-flex mr-3-pc d-flex-mbl"
                      //                             >
                      //                               <img
                      //                                 src={DownloadIconBlue}
                      //                                 alt=""
                      //                                 className="mr-1"
                      //                               />{" "}
                      //                               {i}
                      //                             </a>
                      //                           );
                      //                         }
                      //                       }
                      //                     )}
                      //                 </div>
                      //               </div>
                      //             );
                      //           }

                      //         // })
                      //       }
                               
                      //         })}
                      //       </>
                      //     {/* )    */}
                      //     <hr />
                      //     </>
                      //   );
                      
                      // })
                    }
                      </>
                    )
                    })
                  }

                   
                </div>
              </div>
            </div>
          )}
          </>
          : 
          <></>
          }
          {/* {data.other_documents && (
            <h5 className="fnt-smi-bld mt-3 mb-3">
              {data.other_documents.label}
            </h5>
          )}
          {data.other_documents && (
            <div className="row">
              <div className="col-md-12">
                <div className="common-white-box p-3 mb-4">
                  <div className="d-flex justify-content-between">
                    <h5></h5>
                    {data.other_documents && (
                      <Link to="" className="text-primary">
                        <img src={EditIcon} alt="" className="mr-1" />
                        Edit
                      </Link>
                    )}
                  </div>
                  {data.other_documents &&
                    Object.entries(data.other_documents).map(([i, obj]) => {
                      return (
                        <div className="">
                          <div className="col-md-12 mt-1">{obj.label}</div>
                          {obj &&
                            Object.entries(obj).map(([key, index]) => {
                              if (index.value != "") {
                                return (
                                  <div className="row mt-1">
                                    {index.label && (
                                      <div className="col-md-3  text-muted">
                                        {index.label}
                                      </div>
                                    )}
                                    {index.value && (
                                      <div className="col-md-9 ">
                                        {index.value}
                                      </div>
                                    )}
                                    <div className="col-md-12 ">
                                      {index.preview_url &&
                                        Object.entries(index.preview_url).map(
                                          ([i, url]) => {
                                            return (
                                              <a
                                                href={url}
                                                download
                                                target="_blank"
                                                className="text-primary d-inline-flex mr-3"
                                              >
                                                <img
                                                  src={DownloadIconBlue}
                                                  alt=""
                                                  className="mr-1"
                                                />{" "}
                                                {i}
                                              </a>
                                            );
                                          }
                                        )}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )} */}
          {data.profile_details && (
            <div className="row mb-3">
              <div className="col-md-12 d-flex align-items-center mt-3 mb-3 btn-and-info-responsive">
                {/*<button className="btn btn-outline-secondary btn-lg btn-block-mbl">Back</button>*/}
               {enableSubmit ? <button
                  className="btn btn-primary btn-lg btn-block-mbl mb-1-mbl mr-3"
                  onClick={(e) => saveProfilePreview(e)}
                >
                  Submit
                </button>:<button
                  className="btn btn-primary btn-lg btn-block-mbl mb-1-mbl mr-3"
                  disabled
                >
                  Submit
                </button>}
                <span className="text-muted">
                  Please review as you can not edit after the submission
                </span>
              </div>
            </div>
          )}

                  

          <div class="row">
            <div class="col-md-12">
              <Footer />
            </div>
          </div>


        </div>
      </section>
    </>
  );
};
export default CandidatePreviewFormData;
